<template>
  <div class="card" style="width: 25rem">
    <h3> {{ nftTitle }}</h3>
    <img
      class="card-img-top"
      :src="nftImg"
      style="height: 20rem"
      height="320"
    />
    <p class="card-text"> NFT owner: {{ this.owner }} </p>

    <!-- <button @click="getResult">Load results</button>
    <button @click="showResult">Show results</button> -->
    <!-- <p> -->
    <!-- <h2>NFT owner: {{this.owner}} </h2> -->
        <!-- <ul>
            <li v-for="user in users" :key="user.user">
                {{user.user}} owns {{user.numberOfNFTs}} NFTs 
            </li>
        </ul> -->
        <!-- <ul>
            <li>
                {{user.user}} owns {{user.numberOfNFTs}} NFTs 
            </li>
        </ul> -->
    <!-- </p> -->
    <!-- <router-link :to="'/detail/'+courseId">more detail...</router-link> -->
  </div>
</template>

<script>
import AxiosService from "../services/AxiosService.js";

export default {
  mounted() {
    this.getResult(); // make a request to the server..
  },
  props: ["user", "nftTitle", "nftId", "nftImg"],
  data() {
    return {
      users: [],
      numberOfNFTs: 0,
      owner: "---",
    //   results: [], // we want an array of objects
    //   T0: 0,
    //   T1: 0,
    //   T2: 0,
    //   T3: 0,
    //   T4: 0,
    };
  },
  methods: {
    getResult() {
      AxiosService.getPreRegis()
        .then((response) => {
          const dataArray = [];
          const data = response.data;
          for (const frbId in data) {
            if(data[frbId].nftId === this.nftId ){
              this.owner = data[frbId].user;
                // console.log(this.owner);
               dataArray.push(data[frbId].user)
            }
          }
          this.users = dataArray; 
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // getResult() { 
    // //   alert("Getting the results from the FRB");
    //   AxiosService.getPreRegis()
    //   .then((response)  => {
    //     const data = response.data;
    //     const dataObjArray = [];
    //     for (const id in data) {
    //       const anObj = {};
    //       anObj.nftId = data[id].nftId;
    //       anObj.nftImg = data[id].nftImg;
    //       anObj.nftTitle = data[id].nftTitle;
    //       anObj.user = data[id].user;
    //       if (anObj.user === this.user) {
    //         dataObjArray.push(anObj);
    //       }  
    //     }
    //     this.users = dataObjArray;
    //     this.numberOfNFTs = dataObjArray.length;
    //     // this.showResult();
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // },
    // showResult() {
    //   const arrT0 = this.results.filter((rec) => rec.courseTerm === "0");
    //   const arrT1 = this.results.filter((rec) => rec.courseTerm === "1");
    //   const arrT2 = this.results.filter((rec) => rec.courseTerm === "2");
    //   const arrT3 = this.results.filter((rec) => rec.courseTerm === "3");
    //   const arrT4 = this.results.filter((rec) => rec.courseTerm === "4");

    //   this.T0 = arrT0.length;
    //   this.T1 = arrT1.length;
    //   this.T2 = arrT2.length;
    //   this.T3 = arrT3.length;
    //   this.T4 = arrT4.length;
    // },
  },
};
</script>


<style scoped>
.card {
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
  height: 29rem;
  display: inline-block;
  width: 350px;
  text-align: center;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgb(56, 52, 52);
  border: 2p;
  font-family: Arial, Helvetica, sans-serif;
    /* align-items: center;
   justify-content: center; */
}

.card-text {
    text-decoration: blue;
    font-weight: bold;
}

</style>